
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/durmah-lexicon",
      function () {
        return require("private-next-pages/articles/durmah-lexicon.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/durmah-lexicon"])
      });
    }
  